import { render } from "./departments.vue?vue&type=template&id=501fb89c&scoped=true"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"

import "./departments.vue?vue&type=style&index=0&id=501fb89c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501fb89c"]])

export default __exports__